import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-gs-admin-shell',
    templateUrl: './gs-admin-shell.component.html',
    styleUrls: ['./gs-admin-shell.component.scss'],
})
export class GsAdminShellComponent implements OnInit {
    currentTab: 'settings' = 'settings';

    tabs = [
        { id: 'settings', label: 'Configuración', icon: '⚙️' },
    ];

    constructor(private router: Router, private route: ActivatedRoute) {}

    ngOnInit(): void {
        this.currentTab = 'settings';
    }

    selectTab(tabId: 'settings'): void {
        this.currentTab = tabId;
        this.router.navigate([tabId], { relativeTo: this.route });
    }
}
